const changePasswordFormCopyText = {
  inputPlaceholder_confirmPassword: 'Confirm Password',
  inputPlaceholder_currentPassword: 'Current Password',
  inputPlaceholder_newPassword: 'New Password',
  cancelButtonLabel: 'Cancel',
  saveButtonLabel: 'Save'
};

export default changePasswordFormCopyText;
